import { useSPIntl } from 'hooks/useIntl';
import type { IntlKey } from 'locales';
import { ReactNode } from 'react';
import { Modal, ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useToggle } from 'usehooks-ts';

export type OpenInModalContentProps = {
  modalTitle?: IntlKey | string;
  children: ReactNode;
  isModalOpen?: boolean;
  toggleModal?: () => void;
};
export function OpenInModalContent({
  modalTitle,
  children,
  isModalOpen: isOpen,
  toggleModal: toggle,
}: OpenInModalContentProps) {
  const [isModalOpen, toggleModal] = useToggle();
  const isModalOpenFlag = isOpen ?? isModalOpen;
  const toggleCallback = toggle ?? toggleModal;
  const { idExists } = useSPIntl();
  return (
    <>
      {children}
      <Modal show={isModalOpenFlag} onHide={toggleCallback} size="xl">
        {isModalOpenFlag && (
          <>
            <ModalHeader onToggle={toggleCallback} closeButton>
              <ModalTitle as="h5">
                {idExists(modalTitle) ? <FormattedMessage id={modalTitle} /> : modalTitle}
              </ModalTitle>
            </ModalHeader>
            <ModalBody>{children}</ModalBody>
          </>
        )}
      </Modal>
    </>
  );
}
